import React from 'react';
import { useProgress } from 'components/layout_and_quote_builder/utils/ProgressContext.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

// The listing's modal, blocking progress popup while its manufacturing lines are scored: the legacy
// ProgressBarOverlay's card and determinate percentage bar, but with a short "Loading…" in place of the legacy
// "Loading Layout Combinations" title. The shared ProgressBarOverlay is left EXACTLY as it is for the legacy
// Manufacturing Cost Calculator page; Frank renders this instead, so the shorter wording changes only /mcc.
//
// It reuses the shared overlay's styles (progressOverlay / progressCard / progressTitle / progressBarContainer /
// progressBarFill / progressPercentage), so the popup is pixel-identical to the legacy one apart from the title.
const ListingProgressOverlay = () => {
  const { progress } = useProgress();

  // Nothing queued, or every line already scored -- the popup has nothing to report.
  if (progress.total === 0 || progress.completed === progress.total) {
    return null;
  }

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>Loading…</div>
        <div className={styles.progressBarContainer}>
          <div className={styles.progressBarFill} style={{ width: `${progress.percentage}%` }}>
            <span className={styles.progressPercentage}>{progress.percentage}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingProgressOverlay;
